/* eslint-disable eqeqeq */
import React, { useState, useEffect, useRef } from "react";
import { Col, Form, InputGroup } from "react-bootstrap";
import { useTranslate } from "../../hooks/LanguageProvider";
import SelectReport from "../Vehicle/SelectReport";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/fr"; // Support du français

import { TextField } from "@mui/material";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface VehicleSelectionProps {
  fromDate: (FromDate: Date) => void;
  todDate: (TodDate: Date) => void;
  onVehicleSelect: (vehicles: { id: any; value: any }[]) => void;
}

const VehicleSelection: React.FC<VehicleSelectionProps> = ({
  fromDate,
  todDate,
  onVehicleSelect,
}) => {
  const { translate } = useTranslate();
  const [inputTypeSearchValue, setTypeSearchValue] = useState<number>(11);
  const [inputTypeSearchLabel, setTypeSearchLabel] = useState<string>(
    translate("Matriculation")
  );
  const [inputAdvancedSearch, setInputAdvancedSearch] =
    useState<string>("Vehicle");
  const [loading, setLoading] = useState(true);
  const id_user = localStorage.getItem("userid");
  const Midnight = new Date();
  const MidnightForEndDate = new Date();

  // ✅ Remplacement de Flatpickr par MUI DatePicker
  const [startDate, setStartDate] = useState<Dayjs>(dayjs().startOf("day"));
  const [endDate, setEndDate] = useState<Dayjs>(dayjs().endOf("day"));

  const [suggestions, setSuggestions] = useState([]);
  const [itemsReports, setItemsReports] = useState<{ value: any; id: any }[]>(
    []
  );
  const [autocompleteState, setAutocompleteState] = useState("");
  let [itemSearch, setItemSearch] = useState("");
  const [initialSelectionDone, setInitialSelectionDone] = useState(false);
  const [SearchByIcon, setSearchByIcon] = useState("filter");
  const [SelectReportState, setSelectReportState] = useState(false);
  const [autocompleteStateIcon, setAutocompleteStateIcon] = useState("search");


  const shifts = [
    { label: 'Morning shift', value: 'morning' },
    { label: 'Evening shift', value: 'evening' },
    { label: 'Night shift', value: 'night' },
    { label: 'Daily shift', value: 'daily' },
  ];

  const [selectedShift, setSelectedShift] = useState('');

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const shift = event.target.value;
    setSelectedShift(shift);

    switch (shift) {
      case 'morning':
        setStartDate(dayjs().hour(0).minute(0).second(0));    // 00:00
        setEndDate(dayjs().hour(8).minute(0).second(0));      // 08:00
        break;

      case 'evening':
        setStartDate(dayjs().hour(8).minute(0).second(0));    // 08:00
        setEndDate(dayjs().hour(16).minute(0).second(0));     // 16:00
        break;

      case 'night':
        setStartDate(dayjs().hour(16).minute(0).second(0));   // 16:00 aujourd'hui
        setEndDate(dayjs().endOf('day'));                     // 23:59:59 aujourd'hui
        break;


      case 'daily':
        setStartDate(dayjs().startOf('day'));                 // 00:00
        setEndDate(dayjs().endOf('day'));                     // 23:59:59
        break;

      default:
        setStartDate(dayjs().startOf('day'));
        setEndDate(dayjs().endOf('day'));
    }

  };

  // References to DOM elements
  const inputRef = useRef<HTMLInputElement>(null);
  const suggestionsRef = useRef<HTMLDivElement>(null);

  // Cacher les suggestions si clic en dehors
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Vérifier si le clic est à l'extérieur de l'input ou de la liste de suggestions
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target as Node) &&
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target as Node)
      ) {
        setSuggestions([]); // Masquer les suggestions
      }
    };

    // Ajouter l'écouteur d'événements
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Nettoyage de l'écouteur d'événements
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  interface Vehicle {
    immatriculation_vehicule: string;
    id_dispositif: number;
  }

  interface Driver {
    nom_conducteur: string;
    prenom_conducteur: string;
    id_conducteur: number;
  }

  useEffect(() => {
    if (!initialSelectionDone) {
      onVehicleSelect(itemsReports);
      fromDate(startDate.toDate()); // ✅ Conversion en `Date`
      todDate(endDate.toDate()); // ✅ Conversion en `Date`
      setInitialSelectionDone(true);
    }
  }, []);

  const [searchTypeOptions, setSearchTypeOptions] = useState([
    { value: "11", label: "Matriculation" },
    { value: "12", label: "PSN" },
    { value: "14", label: "Vehicle group" },
    { value: "15", label: "User" },
    { value: "16", label: "Categories" },
  ]);

  const searchBy = async (option: any) => {
    setInputAdvancedSearch(translate(option.label));
    setTypeSearchLabel(translate(option.label));
    setTypeSearchValue(option.value);
    setItemsReports([]);
    setItemSearch("");
  };

  const getAutocomplete = async (search: string) => {
    setItemSearch(search);
    setAutocompleteState("");
    setAutocompleteStateIcon("spinner");

    try {
      if (search.trim() !== "") {
        const res = await fetch(
          `${backendUrl}/api/search/${inputTypeSearchValue}/${search}/${id_user}`,
          { mode: "cors" }
        );
        const data = await res.json();

        const getSuggestions = data.data.map((item: any) => {
          let newItem: any = {};

          if (inputTypeSearchValue == 11 || inputTypeSearchValue == 34) {
            newItem.value = item.immatriculation_vehicule;
            newItem.id = item.id_dispositif;
          } else if (inputTypeSearchValue == 12) {
            newItem.value = item.psn_dispositif;
            newItem.id = item.id_dispositif;
          } else if (inputTypeSearchValue == 14) {
            newItem.value = item.nom_groupe;
            newItem.id = item.id_groupe;
          } else if (inputTypeSearchValue == 15) {
            newItem.value = item.username_user;
            newItem.id = item.id_user;
          } else if (inputTypeSearchValue == 31 || inputTypeSearchValue == 51) {
            newItem.value = item.nom_conducteur + " " + item.prenom_conducteur;
            newItem.id = item.id_dispositif;
          } else if (inputTypeSearchValue == 33) {
            newItem.value = item.nom;
            newItem.id = item.id_agence;
          } else if (inputTypeSearchValue == 32) {
            newItem.value = item.username_user;
            newItem.id = item.id_user;
          }

          return newItem;
        });

        setSuggestions(getSuggestions);
        setAutocompleteStateIcon("search");
      } else {
        setAutocompleteStateIcon("search");
        setSuggestions([]);
      }
    } catch (error) {
      setAutocompleteStateIcon("search");
      setSuggestions([]);
    }
  };

  const getAutocompleteFleet = async (search: string) => {
    setItemSearch("");
    setAutocompleteState("");
    try {
      if (search.trim() !== "") {
        const res = await fetch(
          `${backendUrl}/api/search/${21}/${"fleet"}/${id_user}`,
          { mode: "cors" }
        );
        const data = await res.json();

        const getSuggestions = data.data.map((item: any) => {
          let newItem: any = {};

          newItem.value = item.immatriculation_vehicule;
          newItem.id = item.id_dispositif;

          return newItem;
        });

        setItemsReports(getSuggestions);
        getSuggestions.forEach((item: { value: any }) => {
          updateCheckboxState(item.value);
        });

        setAutocompleteState("");
      } else {
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAutocompleteVehicle = async (id_user: number) => {
    setItemSearch("");
    setAutocompleteState("");
    try {
      const res = await fetch(`${backendUrl}/api/search/vehicle`, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          id_user: id_user,
        }),
      });

      const data = await res.json();

      const getSuggestions = data.map((item: any) => {
        let newItem: any = {};

        newItem.value = item.immatriculation_vehicule;
        newItem.id = item.id_dispositif;

        return newItem;
      });

      setItemsReports(getSuggestions);

      getSuggestions.forEach((item: { value: any }) => {
        //// console.log(item.value);

        updateCheckboxState(item.value);
      });

      setAutocompleteState("");

      return getSuggestions;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const getAutocompleteVehicleByGroup = async (id_groupe: number) => {
    setItemSearch("");
    setAutocompleteState("");
    try {
      const res = await fetch(`${backendUrl}/api/search/group-vehicles`, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          id_groupe: id_groupe,
        }),
      });

      const data = await res.json();

      const getSuggestions = data.map((item: any) => {
        let newItem: any = {};
        newItem.value = item.immatriculation_vehicule;
        newItem.id = item.id_dispositif;

        return newItem;
      });

      setItemsReports(getSuggestions);

      getSuggestions.forEach((item: { value: any }) => {
        updateCheckboxState(item.value);
      });

      setAutocompleteState("");

      return getSuggestions;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const getAutocompleteDriversByIdUser = async (id_user: number) => {
    //setItemSearch("");
    setAutocompleteState("");
    try {
      const res = await fetch(`${backendUrl}/api/search/drivers`, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          id_user: id_user,
        }),
      });

      const data = await res.json();

      // console.log(data)

      const getSuggestions = data.map((item: any) => {
        let newItem: any = {};

        newItem.value = item.nom_conducteur + " " + item.prenom_conducteur;
        newItem.id = item.id_conducteur;

        return newItem;
      });

      setItemsReports(getSuggestions);

      getSuggestions.forEach((item: { value: any }) => {
        //// console.log(item.value);

        updateCheckboxState(item.value);
      });

      setAutocompleteState("");

      return getSuggestions;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const setItems = async (newItem: any) => {
    if (inputTypeSearchValue != 14 && inputTypeSearchValue != 15) {
      const itemExists = itemsReports.some(
        (item) => item.value === newItem.value
      );
      if (!itemExists) {
        const updatedItemsReports = [...itemsReports, newItem];
        setItemsReports(updatedItemsReports);
        setAutocompleteState("autocomplete-state");
        setItemSearch(newItem.value);
        onVehicleSelect(updatedItemsReports);
        fromDate(startDate.toDate()); // ✅ Conversion en `Date`
        todDate(endDate.toDate());
        updateCheckboxState(newItem);
      } else {
        setAutocompleteState("autocomplete-state");
        // console.log("The item already exists in the list.");
      }
    }

    if (inputTypeSearchValue == 15) {
      // console.log("Triggering autocomplete for type search value: " + inputTypeSearchValue);
      const allVehicle = await getAutocompleteVehicle(newItem.id);
      setItemSearch(newItem.value);
      setAutocompleteState("autocomplete-state");
      const selectedVehicles = allVehicle.map((item: any) => ({
        id: item.id,
        value: item.value,
      }));
      onVehicleSelect(selectedVehicles);
      fromDate(startDate.toDate()); // ✅ Conversion en `Date`
      todDate(endDate.toDate());
      updateCheckboxState(newItem);
    }

    if (inputTypeSearchValue == 14) {
      // console.log("Triggering autocomplete for type search value: " + inputTypeSearchValue);
      const allVehicle = await getAutocompleteVehicleByGroup(newItem.id);
      setItemSearch(newItem.value);
      setAutocompleteState("autocomplete-state");
      const selectedVehicles = allVehicle.map((item: any) => ({
        id: item.id,
        value: item.value,
      }));
      onVehicleSelect(selectedVehicles);
      fromDate(startDate.toDate()); // ✅ Conversion en `Date`
      todDate(endDate.toDate());
      updateCheckboxState(newItem);
    }

    if (inputTypeSearchValue == 32) {
      // console.log("Triggering autocomplete for type search value: " + inputTypeSearchValue);
      const allDriver = await getAutocompleteDriversByIdUser(newItem.id);
      setItemSearch(newItem.value);
      setAutocompleteState("autocomplete-state");
      const idDrivers = allDriver.map((item: Driver) => item.id_conducteur);
      onVehicleSelect(idDrivers);
      fromDate(startDate.toDate()); // ✅ Conversion en `Date`
      todDate(endDate.toDate());

      const formattedItems = allDriver.map((item: Driver) => ({
        value: `${item.nom_conducteur} ${item.prenom_conducteur}`,
      }));

      updateAllCheckboxState(formattedItems);
    }
  };

  const addReportBy = async (type: string) => {
    try {
      setLoading(true);
      setSearchByIcon("spinner");
      setAutocompleteStateIcon("spinner");
      setSelectReportState(true);
      const res = await fetch(`${backendUrl}/api/search/report-for/${type}`, {
        mode: "cors",
      });
      const data = await res.json();
      setSearchByIcon("filter");
      setAutocompleteStateIcon("search");
      setSelectReportState(false);
      const optionsArray = data["data"][0]["searchfor"].split(",");
      setSearchTypeOptions(
        optionsArray.map((option: any, index: any) => ({
          value: type.toString() + (index + 1).toString(),
          label: translate(option.trim()),
        }))
      );

      if (type === "2") {
        setSelectReportState(true);
        // console.log("Autocomplete fleet: ");
        setTypeSearchValue(parseInt(type.toString() + "1"));
        getAutocompleteFleet("fleet" + type);
      } else {
        setSelectReportState(false);
        setTypeSearchValue(parseInt(type.toString() + "1"));
        // console.log("Autocomplete: " + type);
      }

      setTypeSearchLabel(translate(optionsArray[0]));
      setInputAdvancedSearch(translate(optionsArray[0]));

      setItemsReports([]);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const checkTypeSelection = () => {
    // Handle the radio button click event for gen_type_manual
  };

  const [checkboxStates, setCheckboxStates] = useState<{
    [key: string]: boolean;
  }>({});
  const [selectAll, setSelectAll] = useState(false);

  const updateCheckboxState = (newItem: { value: any }) => {
    const updatedCheckboxStates = { ...checkboxStates };
    updatedCheckboxStates[newItem.value] = true;
    setCheckboxStates(updatedCheckboxStates);
  };

  const updateAllCheckboxState = (newItems: { value: string }[]) => {
    const updatedCheckboxStates = { ...checkboxStates };

    newItems.forEach((item) => {
      updatedCheckboxStates[item.value] = true; // Cocher tous les items
    });

    setCheckboxStates(updatedCheckboxStates);
  };
  const [createButtonDisabled, setCreateButtonDisabled] = useState(false);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setCheckboxStates((prevState) => ({
      ...prevState,
      [name]: checked,
    }));

    const updatedCheckboxStates = {
      ...checkboxStates,
      [name]: checked,
    };

    const anySelected = Object.values(updatedCheckboxStates).some(
      (value) => value
    );
    setCreateButtonDisabled(!anySelected);

    const selectedVehicles = Object.keys(updatedCheckboxStates)
      .filter((key) => updatedCheckboxStates[key])
      .map((value) => {
        const selectedItem = itemsReports.find((item) => item.value === value);
        return { id: selectedItem?.id, value };
      })
      .filter((item) => item.id !== undefined && item.id !== null);
    onVehicleSelect(selectedVehicles);
  };

  const handleSelectAllChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { checked } = event.target;

    setSelectAll(checked);
    const updatedCheckboxStates: { [key: string]: boolean } = {};
    itemsReports.forEach((item: any) => {
      updatedCheckboxStates[item.value] = checked;
    });
    setCheckboxStates(updatedCheckboxStates);

    const selectedVehicles = itemsReports.map((item) => ({
      id: item.id,
      value: item.value,
    }));
    setCreateButtonDisabled(!checked);
    onVehicleSelect(checked ? selectedVehicles : []);
  };

  const handleStartDateChange = (newDate: Dayjs | null) => {
    if (newDate) {
      if (newDate.isAfter(endDate)) {
        console.warn(
          "⚠️ La date de début ne peut pas dépasser la date de fin !"
        );
        return;
      }

      setStartDate(newDate);
      fromDate(newDate.toDate()); // Mise à jour vers `NewReport`
    }
  };

  const handleEndDateChange = (newDate: Dayjs | null) => {
    if (newDate) {
      if (newDate.isBefore(startDate)) {
        console.warn(
          "⚠️ La date de fin ne peut pas être avant la date de début !"
        );
        return;
      }

      setEndDate(newDate);
      todDate(newDate.toDate()); // Mise à jour vers `NewReport`
    }
  };

  return (
    <div className="report">
      <div className="row" style={{ marginBottom: "15px" }}>
        <div className="row w-100">
          <div className="d-flex flex-wrap gap-3">
            <Col xs={12} md={2} style={{ padding: 0 }}>
              <div
                className="input-group-addon input-sm"
                style={{ paddingRight: "15px", paddingTop: "3px" }}
              >
                {translate("Add report for")}
              </div>
              <div className="d-flex align-items-center">
                <i
                  className={`las la-file-alt icon-report`}
                  style={{ padding: "0px 5px" }}
                />
                <select
                  id="add_report_for"
                  name="add_report_for"
                  onChange={(e) => addReportBy(e.target.value)}
                  className="form-control input-sm"
                >
                  <option value="1">{translate("Vehicles")}</option>
                  <option value="2">{translate("Fleet")}</option>
                  <option value="3">{translate("Drivers")}</option>
                </select>
              </div>
            </Col>

            <Col xs={12} md={2} style={{ padding: 0 }}>
              <SelectReport
                controlId="category_vehicule"
                label={translate("Search") + " type"}
                icon={SearchByIcon}
                options={searchTypeOptions}
                valueType={{
                  value: inputTypeSearchValue,
                  label: translate(inputTypeSearchLabel),
                }}
                onChange={searchBy}
                disabled={SelectReportState}
              />
            </Col>

            <Col xs={12} md={2} style={{ padding: 0 }}>
              <div
                className="input-group-addon input-sm"
                style={{ paddingRight: "15px", paddingTop: "3px" }}
              >
                {translate("Search by")}
              </div>
              <div>
                <div style={{ position: "relative" }}>
                  <div className="d-flex align-items-center">
                    <i
                      className={`las la-${autocompleteStateIcon} icon-report`}
                      style={{ padding: "0px 5px" }}
                    />
                    <Form.Control
                      type="text"
                      placeholder={`${translate(inputAdvancedSearch)}`}
                      className="me-2"
                      aria-label={`${translate(inputAdvancedSearch)}`}
                      onChange={(e) => getAutocomplete(e.target.value)}
                      value={itemSearch}
                      disabled={SelectReportState}
                      ref={inputRef}
                    />
                  </div>
                  <div
                    className={`autocomplete-items ${autocompleteState}`}
                    style={{ listStyleType: "none", padding: 0 }}
                    ref={suggestionsRef}
                  >
                    {suggestions && suggestions.length > 0
                      ? suggestions.map((suggestion: any, index: number) => (
                        <div key={index} onClick={() => setItems(suggestion)}>
                          <p>{suggestion.value}</p>
                        </div>
                      ))
                      : itemSearch &&
                      suggestions.length === 0 && (
                        <div>
                          <p>
                            {translate("None") + " " + translate("Results")}
                          </p>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </Col>

            <Col xs={12} md={2} style={{ padding: 0 }}>
              <div>{translate("Start date")}</div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <i
                  className="las la-calendar d-inline icon-report"
                  style={{ marginRight: "0px", fontSize: "1.2rem" }}
                ></i>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale="fr"
                >
                  <DateTimePicker
                    //label="Date de début"
                    value={startDate}
                    onChange={handleStartDateChange}
                    ampm={false} // Format 24h
                    format="YYYY-MM-DD HH:mm:ss"
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: {
                          "& .MuiOutlinedInput-root": {
                            height: 40, // ✅ Réduit la hauteur
                            fontSize: "14px", // ✅ Texte plus petit
                            "& fieldset": { borderColor: "#ddd" }, // ✅ Bordure orange
                            "&:hover fieldset": { borderColor: "#e76f33" }, // ✅ Bordure plus foncée au survol
                            "&.Mui-focused fieldset": {
                              borderColor: "#d95c1e",
                            }, // ✅ Bordure plus intense en focus
                          },
                          "& .MuiInputLabel-root": {
                            color: "#ff7e41", // ✅ Couleur du label
                          },
                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#d95c1e", // ✅ Couleur du label en focus
                          },
                        },
                      },
                    }} // ✅ Nouvelle méthode
                  />
                </LocalizationProvider>
              </div>
            </Col>

            <Col md={2} style={{ padding: 0 }}>
              <div>{translate("End date")}</div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <i
                  className="las la-calendar d-inline icon-report"
                  style={{ marginRight: "0px", fontSize: "1.2rem" }}
                ></i>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale="fr"
                >
                  <DateTimePicker
                    //  label="Date de fin"
                    value={endDate}
                    onChange={handleEndDateChange}
                    ampm={false}
                    format="YYYY-MM-DD HH:mm:ss"
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        sx: {
                          "& .MuiOutlinedInput-root": {
                            height: 40, // ✅ Réduit la hauteur
                            fontSize: "14px", // ✅ Texte plus petit
                            "& fieldset": { borderColor: "#ddd" }, // ✅ Bordure orange
                            "&:hover fieldset": { borderColor: "#e76f33" }, // ✅ Bordure plus foncée au survol
                            "&.Mui-focused fieldset": {
                              borderColor: "#d95c1e",
                            }, // ✅ Bordure plus intense en focus
                          },
                          "& .MuiInputLabel-root": {
                            color: "#ff7e41", // ✅ Couleur du label
                          },
                          "& .MuiInputLabel-root.Mui-focused": {
                            color: "#d95c1e", // ✅ Couleur du label en focus
                          },
                        },
                      },
                    }} // ✅ Nouvelle méthode
                  />
                </LocalizationProvider>
              </div>
            </Col>

            <Col md={1} style={{ padding: 0 }} >
              <div>Shift</div>
              <div className="d-flex ">     <i className="las la-search icon-report" style={{ padding: "0px 5px;" }}></i>
                <select
                  id="shift"
                  name="shift"
                  value={selectedShift}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500"
                >
                  <option value="" disabled>
                    {translate("Choose a shift")}
                  </option>
                  {shifts.map((shift: any) => (
                    <option key={shift.value} value={shift.value}>
                      {shift.label}
                    </option>
                  ))}
                </select></div>

            </Col>
          </div>
        </div>
      </div>

      <div className="col-md-12 p-0" style={{ marginTop: "15px" }}>
        <div className="row" style={{ marginBottom: "15px" }}>
          <div className="col-md-12">
            <div
              className=""
              style={{
                padding: "3px 9px",
                border: "1px solid #ccc",
                borderBottom: "0px",
              }}
            >
              <input
                id="mf_cb"
                name="selectAll"
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAllChange}
              />
              <span id="mf_title" style={{ fontWeight: "bold" }}>
                {" "}
                <span id="nbrOfVehicle">({itemsReports.length})</span>
                {translate("Vehicles")}
                <div style={{ float: "right" }}>
                  <span className="checkbox" style={{ paddingLeft: "10px" }}>
                    <input
                      type="radio"
                      id="gen_type_manual"
                      name="gen_type"
                      value="manual"
                      onClick={(e) => checkTypeSelection()}
                    />
                    <label htmlFor="gen_type_manual"></label>
                    <span> {translate("Reports")}</span>
                  </span>
                  <span className="checkbox" style={{ paddingLeft: "10px" }}>
                    <input
                      type="radio"
                      id="gen_type_auto"
                      name="gen_type"
                      value="auto"
                      onClick={(e) => checkTypeSelection()}
                    />
                    <label htmlFor="gen_type_auto"></label>
                    <span> {translate("Planning")} </span>
                  </span>
                </div>
              </span>
            </div>
            <div
              className="table-responsive"
              id="scroll"
              style={{
                border: "1px solid #ccc",
                background: "#fff",
                padding: "5px 5px",
                marginBottom: "15px",
                overflow: "auto",
                display: "block",
                height: "333px",
              }}
            >
              <ul
                id="mf_list"
                style={{
                  width: "100%",
                  padding: "5px",
                  listStyleType: "none",
                }}
              >
                {itemsReports &&
                  itemsReports.map((itemsReport: any, index: number) => (
                    <div key={index}>
                      <input
                        type="checkbox"
                        onChange={handleCheckboxChange}
                        checked={checkboxStates[itemsReport.value]}
                        value={itemsReport.value}
                        name={itemsReport.value}
                      />
                      { } {itemsReport.value}
                    </div>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleSelection;
